export default "__VITE_ASSET__b65560dc__"